module.exports = __webpack_public_path__ + "static/ecolambtoy-cf57216b6af645a4db68b7fc02c942a0.jpeg";